export default "__VITE_ASSET__BjKUn$10__"